import React from 'react';
import './AboutAndTestimonials.css';

const AboutAndTestimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Sarah & Mike',
      location: 'New York, NY',
      image: 'https://images.unsplash.com/photo-1522673607200-164d1b6ce486?w=200&h=200&fit=crop',
      quote: 'We matched on Tinder during lockdown and started talking every day. A year later, we got engaged! Tinder gave us the chance to find each other.'
    },
    {
      id: 2,
      name: 'Emma & James',
      location: 'London, UK',
      image: 'https://images.unsplash.com/photo-1517230878791-4d28214057c2?w=200&h=200&fit=crop',
      quote: 'I was hesitant to try online dating, but Tinder made it so easy. James was my first match, and we\'ve been inseparable ever since.'
    },
    {
      id: 3,
      name: 'Alex & Jordan',
      location: 'Sydney, AU',
      image: 'https://images.unsplash.com/photo-1529686342540-1b43aec0df75?w=200&h=200&fit=crop',
      quote: 'We both swiped right not knowing we lived in the same neighborhood. Tinder brought us together, and now we\'re planning our wedding!'
    }
  ];

  const values = [
    {
      icon: '❤️',
      title: 'Love',
      description: 'We believe everyone deserves to find love. Our mission is to spark meaningful connections that last.'
    },
    {
      icon: '🌍',
      title: 'Diversity',
      description: 'We celebrate diversity and welcome people from all backgrounds. Love knows no boundaries.'
    },
    {
      icon: '🔒',
      title: 'Safety',
      description: 'Your safety is our priority. We continuously improve our features to create a secure environment.'
    },
    {
      icon: '💡',
      title: 'Innovation',
      description: 'We\'re always evolving to make dating easier and more enjoyable for everyone.'
    }
  ];

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <h1 className="about-hero-title">About Tinder</h1>
          <p className="about-hero-subtitle">
            We're on a mission to spark meaningful connections that lead to love
          </p>
        </div>
      </section>

      {/* Story Section */}
      <section className="about-story">
        <div className="container">
          <div className="story-content">
            <div className="story-text">
              <h2>Our Story</h2>
              <p>
                Founded in 2012, Tinder revolutionized the dating world with its simple yet brilliant concept: swipe right if you're interested, left if you're not. What started as a small startup in Los Angeles has grown into the world's most popular dating app, with millions of matches made every day.
              </p>
              <p>
                We believe that meeting new people should be fun and easy. That's why we created a platform where you can connect with people you might never have crossed paths with otherwise. Whether you're looking for love, friendship, or just someone to grab coffee with, Tinder is here to help.
              </p>
              <p>
                With over 55 billion matches to date, we've proven that the right connection is just a swipe away. Our community spans 190+ countries, and we're proud to have played a part in countless love stories around the world.
              </p>
            </div>
            <div className="story-image">
              <img 
                src="https://images.unsplash.com/photo-1529543544277-750e440ea1fb?w=600&h=400&fit=crop" 
                alt="Tinder Team" 
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="about-values">
        <div className="container">
          <h2 className="section-title">Our Values</h2>
          <div className="values-grid">
            {values.map((value) => (
              <div key={value.title} className="value-card">
                <span className="value-icon">{value.icon}</span>
                <h3 className="value-title">{value.title}</h3>
                <p className="value-description">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials">
        <div className="container">
          <h2 className="section-title">Success Stories</h2>
          <p className="section-subtitle">
            Real couples who found love on Tinder
          </p>
          <div className="testimonials-grid">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="testimonial-card">
                <div className="testimonial-header">
                  <img 
                    src={testimonial.image} 
                    alt={testimonial.name} 
                    className="testimonial-image"
                  />
                  <div>
                    <h3 className="testimonial-name">{testimonial.name}</h3>
                    <p className="testimonial-location">{testimonial.location}</p>
                  </div>
                </div>
                <p className="testimonial-quote">"{testimonial.quote}"</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="about-stats">
        <div className="container">
          <div className="about-stats-grid">
            <div className="about-stat">
              <span className="about-stat-number">2012</span>
              <span className="about-stat-label">Founded</span>
            </div>
            <div className="about-stat">
              <span className="about-stat-number">500+</span>
              <span className="about-stat-label">Team Members</span>
            </div>
            <div className="about-stat">
              <span className="about-stat-number">190+</span>
              <span className="about-stat-label">Countries</span>
            </div>
            <div className="about-stat">
              <span className="about-stat-number">55B+</span>
              <span className="about-stat-label">Matches</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutAndTestimonials;
